import React, { useEffect, useState } from "react";
import { Badge, Table } from "react-bootstrap";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import TableProperties from "./TableProperties";
import Moment from "react-moment";
import UseToggle from "../../../Hooks/UseToggle";
import { studySiteDataEntryServices } from "../../../APIServices/studySiteDataEntryServices";
import { studyOtherSettingsServices } from "../../../APIServices/studyOtherSettingsServices";
import { NoDataFoundTable, PageLoader } from "../../../Components/NoDataFoundTable/NoDataFoundTable";
import { FaArrowsRotate } from "react-icons/fa6";
import FilterQueryDataList from "./FilterQueryDataList";
import { studySiteManagementServices } from "../../../APIServices/studySiteManagementServices";
import { studySubjectManagementServices } from "../../../APIServices/studySubjectManagementServices";
import { studyEventManagementServices } from "../../../APIServices/studyEventManagementServices";
import Pagination from "../../Pagination";

const ManageQueryDataList = ({ onMouseDown, tableRef, handleAddNewTab }) => {
  const [queryList, setQueryList] = useState([]);
  const [siteList, setSiteList] = useState([]);
  const [subjectList, setSubjectList] = useState([]);
  const [eventList, setEventList] = useState([]);
  const [siteId, setSiteId] = useState("");
  const [subjectId, setSubjectId] = useState("");
  const [eventId, setEventId] = useState("");
  const [timePointId, setTimePointId] = useState("");
  const [type, setType] = useState("");
  const [status, setStatus] = useState("");
  const [queryListCount, setQueryListCount] = useState(0);
  const [totalOpenQuery, setTotalOpenQuery] = useState(0);
  const [totalClosedQuery, setTotalClosedQuery] = useState(0);
  const [totalCancelQuery, setTotalCancelQuery] = useState(0);
  const [totalAnsweredQuery, setTotalAnsweredQuery] = useState(0);
  const [totalAutoQuery, setTotalAutoQuery] = useState(0);
  const [totalManualQuery, setTotalManualQuery] = useState(0);
  const { toggle, setToggle, toggle2, setToggle2 } = UseToggle();
  const [loading, setLoading] = useState(false);
  const [storeLoading, setStoreLoading] = useState(false);
  const [tableColumns, setTableColumns] = useState({});
  let { studyId } = useParams();
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const formColumn = [
    { columnLabel: "SiteId", columnName: "SITEID", columnType: "text" },
    { columnLabel: "SubjectId", columnName: "SUBJECTID", columnType: "text" },
    { columnLabel: "EventId", columnName: "EVENTID", columnType: "text" },
    { columnLabel: "Repeat Event", columnName: "REPEATEVENT", columnType: "text" },
    { columnLabel: "Form Name", columnName: "FORMNAME", columnType: "text" },
    { columnLabel: "Field Name", columnName: "FIELDNAME", columnType: "text" },
    {
      columnLabel: "Generated Date | Time",
      columnName: "GENERATEDDT",
      columnType: "text",
    },
    { columnLabel: "Query Day", columnName: "QUERYDAY", columnType: "text" },
    { columnLabel: "Query Type", columnName: "QUERYTYPE", columnType: "text" },
    { columnLabel: "Status", columnName: "QUERYSTATUS", columnType: "text" },
    { columnLabel: "Answered", columnName: "ANSWERED", columnType: "text" },
  ];

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(15);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(queryListCount / itemsPerPage);

  const getStudyFormFieldQueryHistory = async (e) => {
    setLoading(true);
    let userData = {};
    userData.studyId = studyId;
    userData.mode = StudyMode;
    userData.siteId = siteId;
    userData.subjectId = subjectId;
    userData.eventId = eventId;
    userData.timePointId = timePointId;
    userData.type = type;
    userData.status = status;
    userData.page = pageNumber;
    userData.length = itemsPerPage;
    let data = await studySiteDataEntryServices.getStudyFormFieldQueryHistory(
      userData
    );
    setQueryList(data?.data || []);
    setQueryListCount(data?.count || 0);
    setTotalOpenQuery(data?.totalOpenQuery || 0);
    setTotalClosedQuery(data?.totalClosedQuery || 0);
    setTotalCancelQuery(data?.totalCancelQuery || 0);
    setTotalAnsweredQuery(data?.totalAnsweredQuery || 0);
    setTotalAutoQuery(data?.totalAutoQuery || 0);
    setTotalManualQuery(data?.totalManualQuery || 0);
    setLoading(false);
  };

  const storeStudyFormFieldQueryHistory = async (e) => {
    setStoreLoading(true);
    let userData = {};
    userData.studyId = studyId;
    userData.mode = StudyMode;
    let data = await studySiteDataEntryServices.storeStudyFormFieldQueryHistory(
      userData
    );
    if (data?.statusCode === 200) {
      getStudyFormFieldQueryHistory()
    }
    setStoreLoading(false);
  };

  const getTablePropertiesData = async (e) => {
    let data = await studyOtherSettingsServices.getTablePropertiesData(
      "studyLevelDataQuery",
      studyId
    );
    setTableColumns(data?.data || {});
  };

  const getStudySiteBasedonAccess = async () => {
    let data = await studySiteManagementServices.getStudySiteBasedonAccess(studyId, StudyMode)
    setSiteList(data?.data || [])
  }

  const getStudySubjectRowData = async () => {
    let data = await studySubjectManagementServices.getStudySubjectRowData("active", studyId, siteId, StudyMode)
    setSubjectList(data?.data || [])
  }

  const getStudyEventRowData = async () => {
    let data = await studyEventManagementServices.getStudyEventRowData("active", studyId)
    setEventList(data?.data || [])
  }

  useEffect(() => {
    getTablePropertiesData();
    getStudySiteBasedonAccess()
    getStudyEventRowData()
  }, []);

  useEffect(() => {
    if (siteId) {
      getStudySubjectRowData();
    }
  }, [siteId]);

  useEffect(() => {
    getStudyFormFieldQueryHistory();
  }, [pageNumber, itemsPerPage]);

  const updateTableProperties = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Update Table Property!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Update it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.studyId = studyId;
        userData.type = "studyLevelDataQuery";
        userData.columns = tableColumns;
        let data = await studyOtherSettingsServices.updateTableProperties(
          userData
        );
        if (data?.statusCode === 200) {
          getStudyFormFieldQueryHistory();
          getTablePropertiesData();
        }
      }
    });
  };

  return (
    <>
      <div className="justify-content-between toolbar border-bottom hstack p-1" style={{ height: 36 }}>
        <div className="hstack gap-1">
          <i title="Open Filter" className="fa-solid fa-filter" onClick={setToggle}></i>
          <div className="vr"></div>
          <div className="sync">
            <FaArrowsRotate
              onClick={(e) => {
                if (!storeLoading) {
                  storeStudyFormFieldQueryHistory(e);
                }
              }}
              style={{ marginTop: -5 }}
              title={storeLoading ? "Syncing..." : "Sync now"}
              className={`fontSize12 ${storeLoading ? "rotate360" : "CP"}`}
            />
          </div>
          {storeLoading && <span className="fontSize12">Syncing...</span>}
        </div>
        <div className="hstack gap-2">
          {queryListCount > 0 && (
            <div className="gap-1 hstack">
              <Badge className="br3 p-2 text-danger" bg="danger-subtle" style={{ fontSize: 11 }}>Opened Query: {totalOpenQuery}</Badge>
              <Badge className="br3 p-2 text-success" bg="success-subtle" style={{ fontSize: 11 }}>Closed Query: {totalClosedQuery}</Badge>
              <Badge className="br3 p-2 text-warning" bg="warning-subtle" style={{ fontSize: 11 }}>Cancelled Query: {totalCancelQuery}</Badge>
              <Badge className="br3 p-2 text-secondary" bg="secondary-subtle" style={{ fontSize: 11 }}>Answered Query: {totalAnsweredQuery}</Badge>
              <Badge className="br3 p-2 text-primary" bg="primary-subtle" style={{ fontSize: 11 }}>Auto Query: {totalAutoQuery}</Badge>
              <Badge className="br3 p-2 text-info" bg="info-subtle" style={{ fontSize: 11 }}>Manual Query: {totalManualQuery}</Badge>
              <button
                onClick={() => {
                  setToggle2();
                  getTablePropertiesData();
                }}
                className={`updateProfile`}
              >
                Table Properties
              </button>
            </div>
          )}
        </div>
      </div>
      <div className="overflow-auto" style={{ height: "calc(100vh - 179px)" }}>
        {loading ? (
         <PageLoader/>
        ) : queryListCount === 0 ? (
          <NoDataFoundTable MSG={"Query data list not found!"}/>
        ) : (
          <>
            <Table ref={tableRef} className="m-0 custom-table" hover striped>
              <thead className="position-sticky top-0 z-1">
                <tr>
                  <th
                    onMouseDown={(e) => onMouseDown(e, 0)}
                    style={{ width: 45 }}
                    className="text-center"
                  >
                    Sr.
                  </th>
                  {!tableColumns["SITEID"] && (
                    <th onMouseDown={(e) => onMouseDown(e, 1)} style={{ width: 55 }}>SiteId</th>
                  )}
                  {!tableColumns["SUBJECTID"] && (
                    <th onMouseDown={(e) => onMouseDown(e, 2)} style={{ width: 85 }}>SubjectId</th>
                  )}
                  {!tableColumns["EVENTID"] && (
                    <th onMouseDown={(e) => onMouseDown(e, 3)}>EventId</th>
                  )}
                  {!tableColumns["REPEATEVENT"] && (
                    <th onMouseDown={(e) => onMouseDown(e, 4)} style={{ width: 85 }}>Repeat Event</th>
                  )}
                  {!tableColumns["FORMNAME"] && (
                    <th onMouseDown={(e) => onMouseDown(e, 5)}>Form Name</th>
                  )}
                  {!tableColumns["FIELDNAME"] && (
                    <th onMouseDown={(e) => onMouseDown(e, 6)}>Field Name</th>
                  )}
                  {!tableColumns["GENERATEDDT"] && (
                    <th
                      style={{ width: 150 }}
                      onMouseDown={(e) => onMouseDown(e, 7)}
                    >
                      Generated Date | Time
                    </th>
                  )}
                  {!tableColumns["QUERYDAY"] && (
                    <th
                      style={{ width: 80 }}
                      onMouseDown={(e) => onMouseDown(e, 8)}
                    >
                      Query Day
                    </th>
                  )}
                  {!tableColumns["QUERYTYPE"] && (
                    <th
                      style={{ width: 85 }}
                      onMouseDown={(e) => onMouseDown(e, 9)}
                    >
                      Query Type
                    </th>
                  )}
                  {!tableColumns["ANSWERED"] && (
                    <th
                      style={{ width: 65 }}
                      onMouseDown={(e) => onMouseDown(e, 10)}
                    >
                      Answered
                    </th>
                  )}
                  {!tableColumns["QUERYSTATUS"] && (
                    <th
                      style={{ width: 50 }}
                      onMouseDown={(e) => onMouseDown(e, 11)}
                    >
                      Status
                    </th>
                  )}
                  <th
                    onMouseDown={(e) => onMouseDown(e, 12)}
                    style={{ width: 80 }}
                    className="text-center"
                  >
                    View Form
                  </th>
                </tr>
              </thead>
              <tbody>
                {queryList?.map((dataset, index) => (
                  <tr key={index} title="View Details">
                    <td className="text-center">{index + 1 + startIndex}.</td>
                    {!tableColumns["SITEID"] && <td>{dataset?.siteName}</td>}
                    {!tableColumns["SUBJECTID"] && (
                      <td>{dataset?.subjectName}</td>
                    )}
                    {!tableColumns["EVENTID"] && (
                      dataset?.dataEntryType === "specialForm" ?
                        <td>
                          Special Form
                        </td>
                        :
                        <td>
                          {dataset?.eventName}{" "}
                          {dataset?.timePointLabel &&
                            `(${dataset?.timePointLabel})`}
                        </td>
                    )}
                    {!tableColumns["REPEATEVENT"] && (
                      <td>
                        {dataset?.repeatEvent}
                      </td>
                    )}
                    {!tableColumns["FORMNAME"] && (
                      <td>
                        {dataset?.formName} (v{dataset?.formVersion})
                      </td>
                    )}
                    {!tableColumns["FIELDNAME"] && <td>{dataset?.mainFieldName === dataset?.fieldLabel ? dataset?.fieldLabel : (`${dataset?.mainFieldName} | ${dataset?.fieldLabel || ""}`)}</td>}
                    {!tableColumns["GENERATEDDT"] && (
                      <td>
                        <Moment format="DD MMM YYYY | HH:mm" withTitle>
                          {dataset?.createdAt}
                        </Moment>
                      </td>
                    )}
                    {!tableColumns["QUERYDAY"] && (
                      <td className="text-capitalize">{dataset?.queryDay}</td>
                    )}
                    {!tableColumns["QUERYTYPE"] && (
                      <td className={`text-capitalize ${dataset?.queryType === "auto" ? "text-primary" : "text-info"}`}>{dataset?.queryType} Query</td>
                    )}
                    {!tableColumns["ANSWERED"] && (
                      <td className={`text-capitalize`}>
                        {(!dataset?.answered || dataset?.queryType === "auto") ? "No" : "Yes"}
                      </td>
                    )}
                    {!tableColumns["QUERYSTATUS"] && (
                      <td
                        className={`text-capitalize ${dataset?.status === "open"
                          ? "text-danger"
                          : dataset?.status === "close"
                            ? "text-success"
                            : "text-muted"
                          }`}
                      >
                        {dataset?.status}
                      </td>
                    )}
                    <td className={`text-capitalize text-center`}>
                      <button
                        onClick={() =>
                          handleAddNewTab(
                            dataset?.dataEntryType === "specialForm" ?
                              `Site: ${dataset?.siteName} - Subject: ${dataset?.subjectName} - Event: Special Form` :
                              dataset?.timePointLabel ?
                                `Site: ${dataset?.siteName} - Subject: ${dataset?.subjectName} - Event: ${dataset?.eventName} (${dataset?.timePointLabel})` :
                                `Site: ${dataset?.siteName} - Subject: ${dataset?.subjectName} - Event: ${dataset?.eventName}`,
                            "",
                            "viewEventSchemaFormLists",
                            {
                              siteId: dataset?.siteId,
                              subjectId: dataset?.subjectId,
                              schemaId: dataset?.schemaId,
                              formId: dataset?.formId,
                              formName: dataset?.formName,
                              formVersion: dataset?.formVersion,
                              formType: dataset?.formType,
                              recordId: dataset?.recordId,
                              type: dataset?.dataEntryType === "specialForm" ? "specialForm" : "eventForm",
                              autoForm: "yes",
                              viewType: "dataEntry",
                              eventId: dataset?.eventId,
                              timePointUniqueId: dataset?.timePointUniqueId
                                ? String(dataset?.timePointUniqueId)
                                : "",
                            }
                          )
                        }
                        className={`updateProfile`}
                        style={{ padding: "1px 10px" }}
                      >
                        View
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <div className="position-sticky bottom-0 start-0">
              <Pagination
                totalPage={totalPage}
                pageNumber={pageNumber}
                itemsPerPage={itemsPerPage}
                totalItems={queryListCount}
                setPageNumber={setPageNumber}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </>
        )}
      </div>
      <TableProperties
        Show={!toggle2}
        Hide={setToggle2}
        Title={"Table Properties"}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        formColumn={formColumn}
        tableColumns={tableColumns}
        setTableColumns={setTableColumns}
        updateTableProperties={updateTableProperties}
      />
      <FilterQueryDataList
        Show={!toggle}
        Hide={setToggle}
        Title={"Filter"}
        siteList={siteList}
        subjectList={subjectList}
        eventList={eventList}
        siteId={siteId}
        setSiteId={setSiteId}
        subjectId={subjectId}
        setSubjectId={setSubjectId}
        eventId={eventId}
        setEventId={setEventId}
        timePointId={timePointId}
        setTimePointId={setTimePointId}
        type={type}
        setType={setType}
        status={status}
        setStatus={setStatus}
        getStudyFormFieldQueryHistory={getStudyFormFieldQueryHistory}
      />
      
    </>
  );
};

export default ManageQueryDataList;
